var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('logged-in-template',[(_vm.isLoggedIn)?_c('mental-check-induction-card'):_vm._e(),_c('menu-panel')],1)}
var staticRenderFns = []

export { render, staticRenderFns }